import validate from "C:/Projects/RLA/RLA_FRONT/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "C:/Projects/RLA/RLA_FRONT/middleware/auth.global.ts";
import save_45route_45global from "C:/Projects/RLA/RLA_FRONT/middleware/save-route.global.ts";
import manifest_45route_45rule from "C:/Projects/RLA/RLA_FRONT/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  save_45route_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}